var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.value ? _vm.formatTime(_vm.value,_vm.format) : '-'))])
}
var staticRenderFns = []

export { render, staticRenderFns }